export const defaultMessages = {
  en: {
    next: 'Next',
    back: 'Back',
    nevermind: 'Go Back',
    goToAccount: 'Go to Account',
    getHelp: 'Something Wrong? Contact Us...',
    managedGetHelp: 'Contact Support',
    managedEmailTitle: 'Email Verification',
    managedEmailDescription: 'Enter the email address associated with your account.',
    managedEmailSentTo: 'We have sent a code to',
    managedEmailPlaceholder: 'jane@example.com',
    managedCheckIdentity: 'Send Verification Code', // email initial verification code
    managedVerifyIdentity: 'Verify Account', // check code
    managedDidNotReceiveCode: "Didn't receive a code?",
    managedResendCode: 'Resend',
    declineOffer: 'Decline Offer',
    confirmAndCancel: 'Confirm & Cancel',
    pauseSubscription: 'Pause Subscription',
    cancelSubscription: 'Cancel',
    discountSubscription: 'Accept This Offer', // button to accept discount offer
    claimOffer: 'Claim your limited-time offer', // shown above discount offers
    discountOff: 'off', // e.g. "10% _off_"
    discountFor: 'for', // e.g. "20% off _for_ 2 months"
    discountForever: 'for life', // e.g. "10% off _for life_"
    discountOneTime: 'your next renewal', // e.g. "10% off _your next renewal_"
    day: 'Day | Days', // e.g. "1 day" "2 days"
    month: 'month | months', // e.g. "1 month" "2 months"
    year: 'year | years', // e.g. "1 year" "2 years"
    error: 'Sorry, something went wrong', // generic error message
    genericErrorDescription: 'Please contact us.', // generic error message
    cancelNow: 'Cancel Subscription →', // button to cancel subscription immediately
    applyingDiscount: 'Applying discount...', // shown while applying discount
    applyingCancel: 'Cancelling subscription...', // shown while cancelling subscription
    applyingResume: 'Resuming subscription...', // shown while resuming a paused subscription
    applyingPause: 'Pausing subscription...', // shown while pausing subscription
    discountApplied: 'Discount applied.', // shown when discount is applied
    discountAppliedMessage: "We're so happy you're still here", // shown when discount is applied
    pauseApplied: 'Subscription paused.', // shown when subscription is paused
    pauseAppliedMessage: "You won't be billed until your subscription resumes", // shown when subscription is paused
    pauseAppliedResumeMessage: 'Your subscription will resume on', // shown when subscription is paused
    pauseScheduledMessage: 'Your subscription will be paused beginning', // shown when subscription is scheduled in the future
    until: 'until',
    cancelApplied: 'Subscription cancelled.', // shown when subscription is canceled
    cancelAppliedMessage: "You won't be billed again", // shown when subscription is canceled
    cancelAppliedDateMessage: 'Your subscription will end on', // shown when subscription is canceled
    howLongToPausePrompt: 'Choose how long you want to pause...', // shown above the pause subscription prompt
    whatCouldWeHaveDone: 'What could we have done better?', // shown above the feedback prompt
    weReadEveryAnswer: 'We read every answer...', // shown as placeholder in the feedback prompt
    applyingCustomerAction: 'This will just take a second.', // shown while applying customer action
    loading: 'Loading...', // shown while loading
    pauseWallCardPunch: 'Want access?',
    pauseWallCta: 'Resume Subscription Now',
    pauseWallCardHeading: 'Resume your subscription',
    scheduledToReactivate: "It's scheduled to reactivate on",
    resumeApplied: 'Subscription resumed', // shown when subscription is paused
    resumeAppliedMessage: 'You will be billed at your next subscription renewal period.', // shown when subscription is paused
    resumeNextChargeMessage: "Upon reactivation, you'll be charged at your original rate of ",
    resumeNextChargeMessageWithoutAmount: "Upon reactivation, you'll be charged at your usual rate.",
    resumeAccountDataInfo: 'Your account data is being kept safe for when your subscription resumes.',
    subscriptionPauseNotice: 'Looks like your subscription is still paused',
    failedPaymentNotice: 'Your account access is limited right now',
    chargedMultipleTimeNotice:
      "We've tried a number of times to charge your card on file, but it just hasn't worked out. You're not someone we want to lose, though 👇",
    failedPaymentCardPunch: 'Update your card to restore access.',
    resumeHey: 'Hey',
    invoicePaidTitle: 'Invoice paid successfully',
    invoicePaidDescription: 'Successfully updated your payment information',
    logout: 'Logout →', // used on failed payment and pause wall
    // ex You have a 20% off for 3 months discount valid until October 15. Your existing discount will be overriden upon accepting a new offer.
    note: 'Note:', // shown before the discount note
    discount: 'discount',
    discountNoticeHeadline: "Note: you'll also lose an active discount.",
    discountNoticePrepend: "If you cancel now, you'll lose your current",
    discountOverride: "if you take this offer, you'll lose your current",
    discountValidUntil: "It's good until", // shown on active discount
    updateBilling: 'Update Card',
    // Trial Extension
    extendTrialCTA: 'Extend Trial By ',
    extendTrialPunch: 'Your trial ends on ',
    extendTrialOfferTitle: 'Trial Extension',
    trialExtended: 'Trial extended.',
    trialExtendedMessage: 'Your trial has been extended successfully',
    applyingTrialExtension: 'Extending your trial',
    // Plan Change
    switchPlanCTA: 'Switch Plan',
    changePlanHighlights: 'Highlights',
    changePlanOfferPunch: 'Discounted Secret Plans',
    planChanged: 'Plan changed.',
    planChangedMessage: 'Your new plan is now in effect',
    applyingPlanChange: 'Changing your plan...',
    // Left Theme Step Tags
    surveyStepTag: 'Your Feedback',
    freeFormStepTag: 'Your Feedback',
    finalConfirmation: 'Final Confirmation',
    offerDiscountTag: 'Special Offer',
    offerChangePlanTag: 'Consider Other Plans',
    offerExtendTrialTag: 'Extend Your Trial',
    offerRedirectTag: 'Let Us Help',
    offerContactTag: 'Let Us Help',
    offerPauseTag: 'Subscription Pause',
    completeTag: 'Subscription Cancelled',
    errorTag: 'An Error Occured',
    offerAccepted: 'Offer Accepted',
  },
  de: {
    next: 'Weiter',
    back: 'Zurück',
    nevermind: 'Zurück',
    goToAccount: 'Zum Konto gehen',
    getHelp: 'Brauchst du Hilfe? Kontaktiere uns →',
    declineOffer: 'Angebot ablehnen',
    confirmAndCancel: 'Bestätigen & Abbrechen',
    pauseSubscription: 'Abonnement pausieren →',
    cancelSubscription: 'Abonnement kündigen',
    discountSubscription: 'Dieses Angebot annehmen', // button to accept discount offer
    claimOffer: 'Beanspruche dein zeitlich begrenztes Angebot', // shown above discount offers
    discountOff: 'Rabatt', // e.g. "10% off"
    discountFor: 'für', // e.g. "20% off for 2 months"
    discountForever: 'auf Lebenszeit', // e.g. "10% off for life"
    discountOneTime: 'deine nächste Verlängerung', // e.g. "10% off your next renewal"
    day: 'Tag | Tage', // e.g. "1 day" "2 days"
    month: 'Monat | Monate', // e.g. "1 month" "2 months"
    year: 'Jahr | Jahre', // e.g. "1 year" "2 years"
    error: 'Es tut uns leid, etwas ist schief gelaufen', // generic error message
    genericErrorDescription: 'Bitte versuche es später noch einmal.', // generic error description
    cancelNow: 'Abonnement kündigen →', // button to cancel subscription immediately
    applyingDiscount: 'Rabatt wird angewendet...', // shown while applying discount
    applyingCancel: 'Abonnement wird gekündigt...', // shown while cancelling subscription
    applyingResume: 'Abonnement wird fortgesetzt...', // shown while resuming a paused subscription
    applyingPause: 'Abonnement wird pausiert...', // shown while pausing subscription
    discountApplied: 'Rabatt angewendet', // shown when discount is applied
    discountAppliedMessage: 'Wir freuen uns, dass du immer noch hier bist.', // shown when discount is applied
    pauseApplied: 'Abonnement pausiert', // shown when subscription is paused
    pauseAppliedMessage: 'Du wirst nicht belastet, bis das Abonnement fortgesetzt wird.', // shown when subscription is paused
    pauseAppliedResumeMessage: 'Dein Abonnement wird fortgesetzt am ', // shown when subscription is paused
    cancelApplied: 'Abonnement gekündigt', // shown when subscription is canceled
    cancelAppliedMessage: 'Du wirst nicht mehr belastet werden', // shown when subscription is canceled
    cancelAppliedDateMessage: 'Dein Abonnement endet am ', // shown when subscription is canceled
    howLongToPausePrompt: 'Wähle, wie lange du das Abonnement pausieren möchtest...', // shown above the pause subscription prompt
    whatCouldWeHaveDone: 'Was könnten wir besser gemacht haben?', // shown above the feedback prompt
    weReadEveryAnswer: 'Wir lesen jede Antwort.', // shown above the feedback prompt
    applyingCustomerAction: 'Das dauert nur eine Sekunde.',
    loading: 'Wird geladen...',
    pauseWallCardPunch: 'Zugang möchten?',
    pauseWallCta: 'Abonnement jetzt fortsetzen',
    pauseWallCardHeading: 'Abonnement fortsetzen',
    scheduledToReactivate: 'Die Reaktivierung ist für geplant',
    resumeApplied: 'Abonnement fortgesetzt',
    resumeAppliedMessage: 'Sie werden bei Ihrem nächsten Abonnements-Verlängerungszeitraum in Rechnung gestellt.',
    resumeNextChargeMessage: 'Bei der Reaktivierung werden Sie mit Ihrem ursprünglichen Tarif von ',
    resumeAccountDataInfo: 'Ihre Konto-Daten werden zum Zeitpunkt der Wiederaufnahme Ihres Abonnements sicher aufbewahrt.',
    subscriptionPauseNotice: 'Es sieht so aus, als ob Ihr Abonnement immer noch pausiert ist',
    failedPaymentNotice: 'Der Zugang zu Ihrem Konto ist derzeit eingeschränkt',
    chargedMultipleTimeNotice:
      'Wir haben mehrere Male versucht, Ihre hinterlegte Karte zu belasten, aber es hat nicht funktioniert. Trotzdem wollen wir Sie nicht verlieren 👇',
    failedPaymentCardPunch: 'Aktualisieren Sie Ihre Karte, um den Zugang wiederherzustellen.',
    resumeHey: 'Hallo',
    invoicePaidTitle: 'Rechnung erfolgreich bezahlt',
    invoicePaidDescription: 'Ihre Zahlungsinformationen wurden erfolgreich aktualisiert',
    logout: 'Abmelden →',
    note: 'Hinweis:',
    discount: 'Rabatt',
    discountNoticeHeadline: 'Hinweis: Sie werden auch einen aktiven Rabatt verlieren',
    discountNoticePrepend: 'Wenn Sie jetzt kündigen, verlieren Sie Ihren aktuellen',
    discountOverride: 'Wenn Sie dieses Angebot annehmen, verlieren Sie Ihren aktuellen',
    discountValidUntil: 'Es ist gültig bis',
    updateBilling: 'Karte aktualisieren',
    // Planänderung
    switchPlanCTA: 'Plan wechseln',
    changePlanHighlights: 'Highlights',
    changePlanOfferPunch: 'Rabattierte Geheime Pläne',
    planChanged: 'Plan geändert.',
    planChangedMessage: 'Ihr neuer Plan ist jetzt in Kraft',
    applyingPlanChange: 'Ändern Ihres Plans...',
    // Linke Theme Schritt-Tags
    surveyStepTag: 'Ihr Feedback',
    freeFormStepTag: 'Ihr Feedback',
    finalConfirmation: 'Endgültige Bestätigung',
    offerDiscountTag: 'Sonderangebot',
    offerChangePlanTag: 'Überlegen Sie sich andere Pläne',
    offerExtendTrialTag: 'Verlängern Sie Ihren Probezeitraum',
    offerRedirectTag: 'Lassen Sie uns helfen',
    offerContactTag: 'Lassen Sie uns helfen',
    offerPauseTag: 'Abonnement-Pause',
    completeTag: 'Abonnement gekündigt',
    errorTag: 'Ein Fehler ist aufgetreten',
    offerAccepted: 'Angebot angenommen',
  },
  fr: {
    next: 'Suivant',
    back: 'Retour',
    nevermind: 'Revenir',
    goToAccount: 'Aller à mon compte',
    getHelp: 'Besoin d’aide ? Contactez-nous...',
    declineOffer: 'Refuser l’offre',
    confirmAndCancel: 'Confirmer & Annuler',
    pauseSubscription: 'Mettre en pause l’abonnement',
    cancelSubscription: 'Annuler',
    discountSubscription: 'Accepter cette offre',
    claimOffer: 'Réclamer votre offre limitée dans le temps',
    discountOff: 'de réduction',
    discountFor: 'pendant',
    discountForever: 'à vie',
    discountOneTime: 'à votre prochaine renouvellement',
    day: 'jour | jours',
    month: 'mois | mois',
    year: 'année | années',
    error: 'Désolé, une erreur s’est produite',
    genericErrorDescription: "Contactez nous s'il vous plait.",
    cancelNow: 'Annuler l’abonnement →',
    applyingDiscount: 'Application de la remise en cours...',
    applyingCancel: 'Annulation de l’abonnement en cours...',
    applyingResume: 'Reprise de l’abonnement en cours...',
    applyingPause: 'Mise en pause de l’abonnement en cours...',
    discountApplied: 'Remise appliquée.',
    discountAppliedMessage: 'Nous sommes heureux que vous soyez toujours là',
    pauseApplied: 'Abonnement mis en pause.',
    pauseAppliedMessage: 'Vous ne serez pas facturé jusqu’à la reprise de votre abonnement',
    pauseAppliedResumeMessage: 'Votre abonnement sera repris le',
    cancelApplied: 'Abonnement annulé.',
    cancelAppliedMessage: 'Vous ne serez plus facturé',
    cancelAppliedDateMessage: 'Votre abonnement prendra fin le',
    howLongToPausePrompt: 'Choisissez la durée de votre mise en pause...',
    whatCouldWeHaveDone: 'Que pourrions-nous faire mieux ?',
    weReadEveryAnswer: 'Nous lisons toutes les réponses...',
    applyingCustomerAction: "Cela ne prendra qu'une seconde.", // affiché pendant l'application de l'action client
    loading: 'Chargement...', // affiché pendant le chargement
    pauseWallCardPunch: 'Voulez-vous accéder?',
    pauseWallCta: 'Reprendre Abonnement Maintenant',
    pauseWallCardHeading: 'Reprendre votre abonnement',
    scheduledToReactivate: 'Reprise prévue pour le',
    resumeApplied: 'Abonnement repris', // affiché lorsque l'abonnement est en pause
    resumeAppliedMessage: "Vous serez facturé lors de votre prochaine période de renouvellement d'abonnement.", // affiché lorsque l'abonnement est en pause
    resumeNextChargeMessage: 'Lors de la réactivation, vous serez facturé au taux original de',
    resumeAccountDataInfo: 'Vos données de compte sont conservées en sécurité pour le moment où votre abonnement reprendra.',
    subscriptionPauseNotice: 'Il semble que votre abonnement soit toujours en pause',
    failedPaymentNotice: 'Votre accès au compte est actuellement limité',
    chargedMultipleTimeNotice:
      "Nous avons essayé un certain nombre de fois de débiter votre carte enregistrée, mais cela n'a pas fonctionné. Vous n'êtes pas quelqu'un que nous voulons perdre, cependant 👇",
    failedPaymentCardPunch: "Mettez à jour votre carte pour restaurer l'accès.",
    resumeHey: 'Salut',
    invoicePaidTitle: 'Facture payée avec succès',
    invoicePaidDescription: 'Vos informations de paiement ont été mises à jour avec succès',
    logout: 'Déconnexion →', // utilisé lors d'un paiement échoué et de la pause murale
    // ex Vous avez une réduction de 20% pendant 3 mois valable jusqu'au 15 octobre. Votre remise existante sera remplacée en acceptant une nouvelle offre.
    note: 'Note:', // affiché avant la remarque sur la réduction
    discount: 'réduction',
    discountNoticeHeadline: 'Note: vous perdrez également une réduction active',
    discountNoticePrepend: 'Si vous annulez maintenant, vous perdrez votre',
    discountOverride: 'si vous acceptez cette offre, vous perdrez votre',
    discountValidUntil: "C'est bon jusqu'au", // affiché sur la réduction active
    updateBilling: 'Mettre à jour la carte',
    // Changement de plan
    switchPlanCTA: 'Changer de plan',
    changePlanHighlights: 'Points forts',
    changePlanOfferPunch: 'Plans secrets à prix réduits',
    planChanged: 'Plan modifié.',
    planChangedMessage: 'Votre nouveau plan est maintenant en vigueur',
    applyingPlanChange: 'Changement de votre plan en cours...',
    // Balises de l'étape de thème de gauche
    surveyStepTag: 'Vos commentaires',
    freeFormStepTag: 'Vos commentaires',
    finalConfirmation: 'Confirmation finale',
    offerDiscountTag: 'Offre spéciale',
    offerChangePlanTag: "Considérez d'autres plans",
    offerExtendTrialTag: 'Prolongez votre essai',
    offerRedirectTag: 'Laissons-nous vous aider',
    offerContactTag: 'Laissons-nous vous aider',
    offerPauseTag: "Pause d'abonnement",
    completeTag: 'Abonnement annulé',
    errorTag: "Une erreur s'est produite",
    offerAccepted: 'Offre acceptée',
  },
  es: {
    next: 'Siguiente',
    back: 'Atrás',
    nevermind: 'Volver',
    goToAccount: 'Ir a la cuenta',
    getHelp: '¿Algún problema? Contáctanos →',
    declineOffer: 'Rechazar oferta',
    confirmAndCancel: 'Confirmar y cancelar',
    pauseSubscription: 'Pausar suscripción →',
    cancelSubscription: 'Cancelar suscripción',
    discountSubscription: 'Aceptar oferta', // botón para aceptar la oferta de descuento
    claimOffer: 'Aprovecha esta oferta por tiempo limitado', // se muestra encima de las ofertas de descuento
    discountOff: 'descuento', // ej. "10% de descuento"
    discountFor: 'durante', // ej. "20% de descuento durante 2 meses"
    discountForever: 'para siempre', // ej. "10% de descuento para siempre"
    discountOneTime: 'en tu próxima renovación', // ej. "10% de descuento en tu próxima renovación"
    day: 'día | días', // ej. "1 día" "2 días"
    month: 'mes | meses', // ej. "1 mes" "2 meses"
    year: 'año | años', // ej. "1 año" "2 años"
    error: 'Lo sentimos, algo salió mal', // mensaje de error genérico
    genericErrorDescription: 'Por favor contáctenos.', // descripción genérica del error
    cancelNow: 'Cancelar suscripción →', // botón para cancelar la suscripción de inmediato
    applyingDiscount: 'Aplicando descuento...', // se muestra mientras se aplica el descuento
    applyingCancel: 'Cancelando suscripción...', // se muestra mientras se cancela la suscripción
    applyingResume: 'Reanudando suscripción...', // se muestra mientras se reanuda una suscripción pausada
    applyingPause: 'Pausando suscripción...', // se muestra mientras se pausa la suscripción
    discountApplied: 'Descuento aplicado', // se muestra cuando se aplica el descuento
    discountAppliedMessage: 'Estamos muy felices de que todavía estés aquí.', // se muestra cuando se aplica el descuento
    pauseApplied: 'Suscripción pausada', // se muestra cuando la suscripción se pausa
    pauseAppliedMessage: 'No se te cobrará hasta que reanude la suscripción', // se muestra cuando la suscripción se pausa
    pauseAppliedResumeMessage: 'Tu suscripción se reanudará el ', // se muestra cuando la suscripción se pausa
    cancelApplied: 'Suscripción cancelada',
    cancelAppliedMessage: 'Esperamos verte de nuevo pronto.',
    cancelAppliedDateMessage: 'Tu suscripción se cancelará el',
    howLongToPausePrompt: '¿Cuánto tiempo quieres pausar tu suscripción?',
    whatCouldWeHaveDone: '¿Qué podríamos haber hecho mejor?',
    weReadEveryAnswer: 'Realmente leemos cada respuesta.',
    applyingCustomerAction: 'Esto solo tomará un segundo.',
    loading: 'Cargando...',
    pauseWallCardPunch: '¿Quieres acceso?',
    pauseWallCta: 'Reanudar suscripción ahora',
    pauseWallCardHeading: 'Reanuda tu suscripción',
    scheduledToReactivate: 'Tu suscripción se reanudará el',
    resumeApplied: 'Suscripción reanudada',
    resumeAppliedMessage: 'Se le cobrará en su próximo periodo de renovación de suscripción.',
    resumeNextChargeMessage: 'Al reactivarse, se le cobrará a su tarifa original de',
    resumeAccountDataInfo: 'Sus datos de cuenta se mantienen seguros para cuando reanude su suscripción.',
    subscriptionPauseNotice: 'Parece que su suscripción todavía está en pausa',
    failedPaymentNotice: 'Su acceso a la cuenta está limitado en este momento',
    chargedMultipleTimeNotice:
      'Hemos intentado un número de veces cobrar su tarjeta registrada, pero no ha funcionado. Sin embargo, no eres alguien que queremos perder 👇',
    failedPaymentCardPunch: 'Actualiza tu tarjeta para restaurar el acceso.',
    resumeHey: 'Hola',
    invoicePaidTitle: 'Factura pagada con éxito',
    invoicePaidDescription: 'Sus datos de pago se han actualizado correctamente',
    logout: 'Cerrar sesión →',
    note: 'Nota:',
    discount: 'descuento',
    discountNoticeHeadline: 'Nota: también perderá un descuento activo',
    discountNoticePrepend: 'Si cancela ahora, perderá su actual',
    discountOverride: 'si acepta esta oferta, perderá su actual',
    discountValidUntil: 'Es bueno hasta',
    updateBilling: 'Actualizar tarjeta',
    // Cambio de plan
    switchPlanCTA: 'Cambiar Plan',
    changePlanHighlights: 'Destacados',
    changePlanOfferPunch: 'Planes Secretos con descuento',
    planChanged: 'Plan cambiado.',
    planChangedMessage: 'Su nuevo plan está en efecto',
    applyingPlanChange: 'Cambiando su plan...',
    // Etiquetas de paso del tema de la izquierda
    surveyStepTag: 'Su opinión',
    freeFormStepTag: 'Su opinión',
    finalConfirmation: 'Confirmación final',
    offerDiscountTag: 'Oferta especial',
    offerChangePlanTag: 'Considere otros planes',
    offerExtendTrialTag: 'Extienda su prueba',
    offerRedirectTag: 'Permítenos ayudarte',
    offerContactTag: 'Permítenos ayudarte',
    offerPauseTag: 'Pausa de suscripción',
    completeTag: 'Suscripción cancelada',
    errorTag: 'Ops... Algún error ocurrió',
    offerAccepted: 'Oferta aceptada',
  },
};
